<template>
  <VuepalLink :to="url?.path" class="teaser">
    <figure class="teaser-image">
      <MediaImage
        v-if="media"
        :image="media.image"
        :image-style="articleTeaser"
        class="image is-square is-rounded"
      />
    </figure>
    <h4 class="title is-5 is-spaced">{{ title }}</h4>
    <div v-if="benefit" class="subtitle is-6" v-html="benefit" />
    <div v-if="showLead && lead" class="teaser-text" v-html="lead" />
  </VuepalLink>
</template>

<script setup lang="ts">
import type { NodeBenefitTeaserFragment } from '#graphql-operations'

defineProps<{
  showLead?: boolean
  nid?: number
  title?: string
  lead?: string
  url?: NodeBenefitTeaserFragment['url']
  media?: NodeBenefitTeaserFragment['media']
  benefit?: string
}>()

const articleTeaser = defineImageStyle({
  type: 'sizes',
  aspectRatio: 1,
  sizes: {
    xs: 255,
  },
})
</script>
